export default __webpack_public_path__ + "static/media/fastingfatburn@2x.42e395d4.jpg";